<template>
  <div class="md:relative w-full text-right md:w-auto ltr:maxMd:pr-3 rtl:maxMd:pl-3">
    <!-- the GUI icon -->
    <button @click="showPopover()" ref="button" class="toggle-button">
      <div
        class="cursor-pointer h-[40px] w-[40px] border border-white bg-blue rounded-full font-display font-bold text-[18px] text-white text-center py-2 leading-6 md:leading-[26px]">
        {{ extractInitials }}
      </div>
    </button>
    <!-- the popover -->
    <div v-if="displayHide"
      class="fixed md:absolute top-16 ltr:right-0 rtl:left-0 z-9 w-full md:hidden h-screen md:h-[90vh] bg-blue z-[51]">
    </div>
    <div v-closable="{ exclude: ['button'], handler: 'onClose', isOpen: displayHide }" v-if="displayHide"
      class="fixed md:absolute top-20 md:top-16 ltr:right-0 rtl:left-0 z-[51] w-full md:w-auto">
      <div
        class="w-[90%] md:w-[300px] pt-5 pb-4 bg-white rounded-md shadow-ts1 m-auto flex flex-col justify-center items-center border border-solid border-gray-300">
        <div class="flex flex-col justify-center items-center">
          <!-- image div -->
          <div>
            <div
              class="h-[80px] w-[80px] bg-blue rounded-full text-2xl font-display font-bold text-white text-center py-7">
              {{ extractInitials }}</div>
          </div>
          <div class="text-center mt-3 mb-2.5">
            <div v-if="verified == true" class="px-8 text-green text-xs font-semibold pb-1">
              {{ $t('verified_account') }}
            </div>
            <div v-else-if="isPending" class="px-8 text-orange-light text-xs font-semibold pb-1">
              {{ $t('pending_account').tTitle() }}
            </div>
            <div class="font-display font-bold text-lg text-gray-900">{{ capitalizedFirstName }} {{ capitalizedLastName
              }}</div>
            <div class="font-body text-xs text-gray-900">{{ emailAddress }}</div>
          </div>
          <!-- button  -->
          <div v-if="showManageYourAccount" class="mb-8 mx-10">
            <Button mode="primary-outlined" size="small" customClasses="!py-2 px-[25px] w-auto !font-normal">
              <router-link :to="'/' + Language + '/profile'" @click.native="showPopover()">
                {{ $t('mng_your_ac') }}
              </router-link>
            </Button>
          </div>
        </div>
        <!-- separation line hr -->
        <div class="bg-gray-300 w-full h-px"></div>

        <!-- help button  -->
        <Button size="small" customClasses="mt-4 !w-[270px] !py-2 !font-normal">
          <a :href="contactLink" target="_blank">
            {{ $t('help') }}
          </a>
        </Button>

        <!-- log out button -->
        <Button @click="logout()" mode="white" size="small" customClasses="mb-6 !w-[270px] !py-2 !font-normal">
          {{ $t('sign_out').tTitle() }}
        </Button>

        <!-- separation line hr -->
        <div class="bg-gray-300 w-full h-px"></div>

        <!-- Terms | Privacy | Risk Disclosure -->
        <div class="font-body text-xs text-center text-gray-900 pt-3">
          <a :href="privacyPolicyLink" target="_blank">{{ $t('privacy') }}</a> |
          <a :href="riskDisclosureLink" target="_blank">{{ $t('risk_disclosure').tCapitalizeFirstLetter() }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../config'
import { mapGetters } from 'vuex'
import links from '../config/links'
import Button from './reusableComponents/Button.vue'

export default {
  name: 'ProfilePopover',
  components: { Button },
  props: ['first_name', 'last_name', 'coName', 'emailAddress', 'verified'],
  data() {
    return {
      displayHide: false,
      websiteURL: config.URL.website,
      showManageYourAccount: true,
      isPending: false,
    }
  },
  watch: {
    isEmailVerified(v) {
      if (v !== undefined) {
        if (v.verified) {
          this.showManageYourAccount = true
        } else {
          this.showManageYourAccount = false
        }
      }
    },
    UserInfo: {
      immediate: true,
      deep: true,
      handler(u) {
        if (u.ID <= 0) {
          return
        }
        if (u.client) {
          const accountState = u.client.account_state
          if (accountState == 'pending') {
            this.isPending = true
          }
        }
      },
    },
  },
  mounted() {},
  computed: {
    capitalizedFirstName() {
      if (this.first_name) {
        return this.first_name[0].toUpperCase() + this.first_name.substring(1)
      } else if (this.coName) {
        return this.coName[0].toUpperCase() + this.coName.substring(1)
      } else return ''
    },
    capitalizedLastName() {
      if (this.lastName !== undefined && this.last_name !== '') {
        return this.last_name[0].toUpperCase() + this.last_name.substring(1)
      } else return ''
    },
    extractInitials() {
      let initials = ''
      if (this.first_name && this.last_name) {
        initials = this.first_name.charAt(0) + this.last_name.charAt(0)
        return initials.toUpperCase()
      } else if (this.coName) {
        initials = this.coName.charAt(0)
        return initials.toUpperCase()
      } else {
        return ''
      }
    },
    privacyPolicyLink() {
      return links.getLink('privacyPolicy', 'en')
    },
    riskDisclosureLink() {
      return links.getLink('riskDisclosure', 'en')
    },
    contactLink() {
      return links.getLink('contact', 'en')
    },

    ...mapGetters({
      Language: 'language/code',
      isEmailVerified: 'user/isEmailVerified',
      UserInfo: 'user/info',
    }),
  },
  methods: {
    showPopover() {
      this.displayHide = !this.displayHide
    },
    onClose() {
      this.displayHide = false
    },
    logout() {
      this.$emit('log-out')
    },
  },
}
</script>
